var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import MenuLabel from "@irati/ui/src/Account/SideBar/styled/MenuLabel";
var MenuLink = function (props, _a) {
    var appPath = _a.appPath;
    var linkProps = __assign({}, props);
    linkProps.isCurrent = window.location.pathname === "" + appPath + props.to;
    return React.createElement(MenuLabel, __assign({}, linkProps));
};
MenuLink.contextTypes = {
    appPath: PropTypes.string.isRequired
};
export default styled(MenuLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 10px;\n  margin: 0;\n  font-weight: bold;\n  color: ", ";\n  padding: ", ";\n"], ["\n  font-size: 10px;\n  margin: 0;\n  font-weight: bold;\n  color: ", ";\n  padding: ", ";\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.colors.greys.mediumDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.two;
});
var templateObject_1;
